export default __webpack_public_path__ + "static/media/heroImgCR3-Mob.4f11f1ea.jpg";